'use client';

import { AppErrorView } from '@/components/error/AppErrorView';

type ErrorPageProps = {
  error: Error & { digest?: string };
  unstable_retry: () => void;
};

/**
 * 라우트 렌더링 중 발생한 예외를 사용자 친화적인 복구 화면으로 안내합니다.
 */
export default function ErrorPage({ unstable_retry }: ErrorPageProps) {
  return (
    <AppErrorView
      actions={[
        { label: '다시 시도', onClick: unstable_retry, variant: 'primary' },
        { href: '/', label: '처음 화면으로', variant: 'secondary' },
      ]}
      code="오류"
      description="일시적인 문제로 화면을 불러오지 못했습니다. 잠시 후 다시 시도하거나 처음 화면에서 다시 진입해 주세요."
      documentTitle="화면을 불러오지 못했습니다"
      eyebrow="서비스 오류 안내"
      title="화면을 불러오지 못했습니다."
    />
  );
}
